import React from "react";
import Select from "react-select";
import "./MultiSelect.css";
import { Controller } from "react-hook-form";

const MultiSelectWrapper = ({
  options,
  errors,
  name,
  label,
  mandatory,
  control,
  isMulti = true,
}) => {
  const customStyles = {
    // option: (provided, state) => ({
    //   ...provided,
    //   color: state.isSelected ? "var(--white3-color)" : "var(--black-color)",
    // }),
    option: (provided, state) => ({
      ...provided,
      width: "100%",
      zIndex: 1000,
      color: state.isFocused
        ? document?.getElementById("contrast")
          ? "#ffffff"
          : "var(--white3-color)"
        : state.isSelected
        ? document?.getElementById("contrast")
          ? "#ffffff"
          : "var(--white3-color)"
        : "var(--black-color)",
      background: state.isFocused
        ? document?.getElementById("contrast")
          ? "#951b1d"
          : "var(--green-color)"
        : provided.background,
      ":hover": {
        background: document?.getElementById("contrast")
          ? "#951b1d"
          : "var(--green-color)",
        color: document?.getElementById("contrast")
          ? "#ffffff"
          : "var(--white-font-color)",
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      background: document?.getElementById("contrast")
        ? "#951b1d"
        : "var(--primary-color)",
    }),

    control: (base, state) => ({
      ...base,
      background: "var(--secondary-color)",
      fontSize: "12px",
      borderColor: state.isFocused
        ? "var(--active-color)"
        : errors && errors[name]
        ? "var(--orange-error-color)"
        : "var(--white3-color)",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused
          ? "var(--active-color)"
          : "var(--white3-color)",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: document?.getElementById("contrast")
        ? "#D9D9D9"
        : "var(--white-font-color)",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: document?.getElementById("contrast")
        ? "#ffffff"
        : "var(--red-color)",
      ":hover": {
        background: document?.getElementById("contrast")
          ? "#951b1d"
          : "var(--secondary-color)",
        color: document?.getElementById("contrast")
          ? "#ffffff"
          : "var(--red-color)",
      },
    }),
    // dropdownIndicator: (base) => ({
    //   ...base,
    //   color: "var(var(--green-color))", // Custom colour
    // }),
    dropdownIndicator: (base) => ({
      ...base,
      color: document?.getElementById("contrast")
        ? "#252B48"
        : "var(--white-font-color)",
      "&:hover": {
        color: document?.getElementById("contrast")
          ? "#252B48"
          : "var(--white-font-color)",
      },
    }),
    clearIndicator: (provided) => ({
      ...provided,
      color: document?.getElementById("contrast")
        ? "#951b1d"
        : "var(--red-color)",
      ":hover": {
        color: document?.getElementById("contrast")
          ? "#951b1d"
          : "var(--red-color)",
        cursor: "pointer",
      },
    }),
  };

  return (
    <div className="multiselect__regs--form">
      <label className="form__label">
        {label} {mandatory && <span className="asterisk">*</span>}
      </label>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => (
          <Select
            styles={customStyles}
            placeholder="Select option"
            classNamePrefix="react-select"
            theme={(theme) => ({
              ...theme,
              borderRadius: 0,
              colors: {
                ...theme.colors,
                primary25: document?.getElementById("contrast")
                  ? "#951b1d"
                  : "var(--green-color)",
                neutral50: "var(--white3-color)",
                neutral80: document?.getElementById("contrast")
                  ? "#ffffff"
                  : "var(--white3-color)",
                primary: "var(--black-color)",
              },
            })}
            value={value}
            onChange={onChange}
            options={options}
            isMulti={isMulti}
            isSearchable={true}
          />
        )}
      />

      <p className="error__message">{errors[name]?.message}</p>
    </div>
  );
};

export default MultiSelectWrapper;
